import { styled, Button } from "@chakra-ui/react";

export const SecondaryButton = styled(Button, {
	baseStyle: {
		color: "white",
		borderRadius: "6px"
	}
});
